import React, { FC } from 'react';

import Rive, { Fit, Layout } from '@rive-app/react-canvas';
import clsx from 'clsx';

import { Loader as DesignSystemLoader } from '~/design-system/components/Loader/Loader';
import { useIsHomePageRedesignEnabled } from '~/modules/home/useIsHomePageRedesignEnabled';

import styles from './styles.module.scss';

type Props = {
  isLoading?: boolean;
  className?: string;
  children?: React.ReactNode;
};

const Loader: FC<Props> = ({ className, isLoading = true, children }) => {
  const isHomePageRedesignEnabled = useIsHomePageRedesignEnabled();

  if (!isLoading) {
    return <>{children}</>;
  }

  return (
    <div className={styles.loader_wrapper}>
      {isHomePageRedesignEnabled ? (
        <DesignSystemLoader className={className} />
      ) : (
        <div className={clsx(styles.animation, className)}>
          <Rive
            layout={
              new Layout({
                fit: Fit.Cover,
              })
            }
            shouldResizeCanvasToContainer
            src="/animations/loader.riv"
          />
        </div>
      )}
    </div>
  );
};

export default Loader;
